import Fields from './Fields'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.zen_report.ratings.fields", Fields),
            sortOrder: [
                {
                    field: 'viewsRank',
                    direction: 'asc'
                },
            ],
            additionalActions: [],
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
